/* unplugin-vue-components disabled */import { render } from "./ResizePane.vue?vue&type=template&id=22af7863"
import script from "./ResizePane.vue?vue&type=script&lang=js"
export * from "./ResizePane.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__